export enum UserTypes{
    TvSpotter = 1,
    TvCommentator = 2,
    Speaker = 11,
    Trainer = 21,
    Spectator = 31,
    TvCommentatorNoPreTime = 3,
    SpeakerNoPreTime = 12,
}